<bb-page-header [icon]="'files'" [title]="'REPORTS' | translate" [filterConfig]="filterConfig"></bb-page-header>

<div class="body-column">
	<div class="action-buttons">
		<a class="button" [routerLink]="['/analytics/reports', 'new', 'contents']"><i class="fa fa-plus"></i>
			<span class="short-label">{{ 'CREATE_NEW' | translate }}</span>
			<span class="long-label">{{ 'CREATE_NEW_REPORT' | translate }}</span>
		</a>
	</div>

	<bb-table-container>
		<bb-table-header>
			<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="title" class="overflow">{{ 'TITLE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="dummy">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell property="createddate" class="date">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="updateddate" class="date">{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="status">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell property="id">{{ row.data.id }}</bb-table-cell>
			<bb-table-cell property="title" class="overflow">{{ row.data.title }}</bb-table-cell>
			<bb-table-cell class="dummy">&nbsp;</bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{ row.data.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}</bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{ row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">{{ row.data.updatedBy }}</bb-table-cell>
			<bb-table-cell property="status"><div [innerHtml]="row.data | statusIcon"></div></bb-table-cell>
			<bb-table-cell class="buttons" (click)="$event.stopPropagation()"><!-- stopPropagation so the row doesn't get selected -->
				<a class="button" [routerLink]="['/analytics/reports/', row.data.id, 'contents']">
					<i class="fa fa-edit"></i>
				</a>
				<a class="button" (click)="duplicate(row.data.id)">
					<i class="fa fa-copy"></i>
				</a>
				<a class="button" (click)="deleteSingle(row.data)">
					<i class="fa fa-trash"></i>
				</a>
			</bb-table-cell>
		</bb-table-row>
	</bb-table-container>

	<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_REPORTS_FOUND' | translate }}</div>

	<bb-table-pager></bb-table-pager>

</div>
